/** Admin role code → display label */
export const ADMIN_ROLE_LABELS: Record<string, string> = {
  admin: '管理员',
  editor: '编辑',
  viewer: '访客',
}

export const ADMIN_ROLE_OPTIONS = [
  { label: '管理员', value: 'admin' },
  { label: '编辑', value: 'editor' },
  { label: '访客', value: 'viewer' },
]

export function getAdminRoleLabel(role?: string | null) {
  if (!role) return '-'
  return ADMIN_ROLE_LABELS[role] || role
}

/** Admin user account status */
export const ADMIN_USER_STATUS_LABELS: Record<number, string> = {
  0: '禁用',
  1: '启用',
}

export const ADMIN_USER_STATUS_OPTIONS = [
  { label: '启用', value: 1 },
  { label: '禁用', value: 0 },
]

export function getAdminUserStatusLabel(status?: number | null) {
  if (status === null || status === undefined) return '-'
  return ADMIN_USER_STATUS_LABELS[status] ?? String(status)
}

/** Admin user gender: 0=female 1=male */
export const ADMIN_USER_GENDER_LABELS: Record<number, string> = {
  0: '女',
  1: '男',
}

export const ADMIN_USER_GENDER_OPTIONS = [
  { label: '男', value: 1 },
  { label: '女', value: 0 },
]

export function getAdminUserGenderLabel(gender?: number | null) {
  if (gender === null || gender === undefined) return '-'
  return ADMIN_USER_GENDER_LABELS[gender] ?? String(gender)
}

export function getAdminUserAvatarSrc(gender?: number | null) {
  return gender === 0 ? '/images/avatar/female.svg' : '/images/avatar/male.svg'
}

/** News status → display label */
export const NEWS_STATUS_LABELS: Record<number, string> = {
  [-1]: '已删除',
  0: '草稿',
  1: '已发布',
  2: '已下架',
}

export const NEWS_STATUS_OPTIONS = [
  { label: '草稿', value: 0 },
  { label: '已发布', value: 1 },
  { label: '已下架', value: 2 },
]

export function getNewsStatusLabel(status?: number | null) {
  if (status === null || status === undefined) return '-'
  return NEWS_STATUS_LABELS[status] ?? String(status)
}
